import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const SuccessPageStyles = styled(OnboardingPage)<{
  backgroundImage?: string;
}>`
  --success-payment-next-actions-border-bottom: 1px solid #fff;

  body.dark & {
    --success-payment-next-actions-border-bottom: 1px solid #ffffff4d;
  }

  ion-content {
    position: relative;
    --background: ${(props) =>
      props.backgroundImage
        ? `linear-gradient(180deg, rgba(20, 17, 30, 0) 17.77%, #14111E 60%), url(${props.backgroundImage}) no-repeat top center / contain`
        : 'linear-gradient(180deg, #2b0e21 0%, #43285B 100%)'};

    display: flex;
    flex-direction: column;
  }

  .content {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2;
    padding: 0 24px 24px;

    .success-payment-title {
      border-bottom: var(--success-payment-next-actions-border-bottom);
      padding-bottom: 20px;
    }

    .next-actions {
      margin: 30px auto 13px;
      max-width: max-content;
      padding: 0 0 20px;
      border-bottom: var(--success-payment-next-actions-border-bottom);

      .next-action-description {
        margin: 0 0 14px;
      }
    }

    .questions-email {
      margin: 0 auto;

      a {
        color: inherit;
      }
    }
  }
`;

export const StoresLinks = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  max-width: 380px;
  width: 100%;
  margin: 0 auto 14px;

  a {
    display: block;
    aspect-ratio: 1 / 0.29;
    width: 166px;
    font-size: 0;
    line-height: 0;

    @media screen and (min-width: 576px) {
      width: 168px;
    }

    img {
      height: 100%;
      width: 100%;
    }
  }
`;

export const WebVersionLink = styled.div`
  width: 100%;
  border-radius: 6px;
  border: 1px solid #a6a6a6;
  background: #000;
  color: #fff;
  padding: 8px 16px;
  max-width: 380px;
  width: 100%;
  margin: 0 auto 14px;

  a {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: inherit;
    font-weight: bold;
    text-decoration: none;

    ion-icon {
      font-size: 24px;
    }
  }
`;
